/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { categoryControllerCreate } from '../fn/category/category-controller-create';
import { CategoryControllerCreate$Params } from '../fn/category/category-controller-create';
import { categoryControllerDelete } from '../fn/category/category-controller-delete';
import { CategoryControllerDelete$Params } from '../fn/category/category-controller-delete';
import { categoryControllerFindAll } from '../fn/category/category-controller-find-all';
import { CategoryControllerFindAll$Params } from '../fn/category/category-controller-find-all';
import { categoryControllerFindAllTree } from '../fn/category/category-controller-find-all-tree';
import { CategoryControllerFindAllTree$Params } from '../fn/category/category-controller-find-all-tree';
import { categoryControllerFindById } from '../fn/category/category-controller-find-by-id';
import { CategoryControllerFindById$Params } from '../fn/category/category-controller-find-by-id';
import { categoryControllerSwapOrder } from '../fn/category/category-controller-swap-order';
import { CategoryControllerSwapOrder$Params } from '../fn/category/category-controller-swap-order';
import { categoryControllerUpdate } from '../fn/category/category-controller-update';
import { CategoryControllerUpdate$Params } from '../fn/category/category-controller-update';
import { CategoryDto } from '../models/category-dto';

@Injectable({ providedIn: 'root' })
export class CategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `categoryControllerFindAll()` */
  static readonly CategoryControllerFindAllPath = '/api/categories';

  /**
   * 모든 Category 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindAll$Response(params?: CategoryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryDto>>> {
    return categoryControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Category 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindAll(params?: CategoryControllerFindAll$Params, context?: HttpContext): Observable<Array<CategoryDto>> {
    return this.categoryControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CategoryDto>>): Array<CategoryDto> => r.body)
    );
  }

  /** Path part for operation `categoryControllerCreate()` */
  static readonly CategoryControllerCreatePath = '/api/categories';

  /**
   * Category 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerCreate$Response(params: CategoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Category 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerCreate(params: CategoryControllerCreate$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerFindAllTree()` */
  static readonly CategoryControllerFindAllTreePath = '/api/categories/tree';

  /**
   * 모든 Category 목록을 트리형태로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerFindAllTree()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindAllTree$Response(params?: CategoryControllerFindAllTree$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryDto>>> {
    return categoryControllerFindAllTree(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Category 목록을 트리형태로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerFindAllTree$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindAllTree(params?: CategoryControllerFindAllTree$Params, context?: HttpContext): Observable<Array<CategoryDto>> {
    return this.categoryControllerFindAllTree$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CategoryDto>>): Array<CategoryDto> => r.body)
    );
  }

  /** Path part for operation `categoryControllerFindById()` */
  static readonly CategoryControllerFindByIdPath = '/api/categories/{id}';

  /**
   * Category id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindById$Response(params: CategoryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Category id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerFindById(params: CategoryControllerFindById$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerDelete()` */
  static readonly CategoryControllerDeletePath = '/api/categories/{id}';

  /**
   * Category 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerDelete$Response(params: CategoryControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return categoryControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Category 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryControllerDelete(params: CategoryControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.categoryControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `categoryControllerUpdate()` */
  static readonly CategoryControllerUpdatePath = '/api/categories/{id}';

  /**
   * Category 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerUpdate$Response(params: CategoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryDto>> {
    return categoryControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Category 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerUpdate(params: CategoryControllerUpdate$Params, context?: HttpContext): Observable<CategoryDto> {
    return this.categoryControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryDto>): CategoryDto => r.body)
    );
  }

  /** Path part for operation `categoryControllerSwapOrder()` */
  static readonly CategoryControllerSwapOrderPath = '/api/categories/swap-order';

  /**
   * Category 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryControllerSwapOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerSwapOrder$Response(params: CategoryControllerSwapOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return categoryControllerSwapOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * Category 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `categoryControllerSwapOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryControllerSwapOrder(params: CategoryControllerSwapOrder$Params, context?: HttpContext): Observable<void> {
    return this.categoryControllerSwapOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
